<div class="container mt-2 pb-4" >
  <div class="row">
    <div class="race-preview shadow p-0">
      <div class="race-header">
        <div class="btn_selection-back" (click)="backToMettingView()">
          <ion-icon style="color: black;" name="arrow-back-outline"></ion-icon>
        </div>

        <div class="race-info">
          <div style="color: black;" class="race-name">{{selectedMeeting.eventLabel}}</div>
          <div style="color: black;" class="race-description">{{selectedMeeting.eventName}}</div>
        </div>
        <div class="race-extra">
          <span style="color: black;" class="t-strong">{{selectedMeeting.eventTime}}</span>
          <span style="color: black;" class="secondary">{{selectedMeeting.eventLocalDate}}</span>
        </div>
        <div class="extra ml-2">

          <button
            [disabled]="selectedMeeting.eventLabel.substr(selectedMeeting.eventLabel.length-3,2)=='VR' || (!is_logged && selectedMeeting.eventLabel.substr(selectedMeeting.eventLabel.length-3,2) == 'AU')"
            (click)="viewEventDetails(selectedMeeting)" class="btn btn-tertiary icon ml-2">
            <span class="icon icon-info"></span>
          </button>


        </div>
      </div>
      <div class="race-content">
        <ul class="list-group list-group-flush">
          <li class="list-group-item" *ngFor="let odd of selectionOdds; index as i">
            <div class="avatar-wrapper">
              <div class="number">{{odd.selectionNumber}}</div>
              <img *ngIf="odd.name != 'Favourite' || (odd.name == 'Favourite' && odd.sportCategoryId!='DG') "
                [src]="odd.jerseyIcon != 'NA' && odd.showJersey=='Y' ? 'data:image/gif;base64,' + odd.jerseyIcon : '../../../../assets/icon/default-jersey.png'  "
                alt="Wile" class="avatar">
              <img *ngIf="odd.name == 'Favourite' && odd.sportCategoryId=='DG' "
                src="../../../../assets/icon/default-greyHound.png" alt="Wile" class="avatar">
            </div>
            <div class="info">
              <div style="color: black;" class="title">{{odd.name}}</div>
              <div style="color: rgb(54, 54, 54);" class="description">{{odd.jockey}}</div>
            </div>
            <div class="extra">
              <button
                [disabled]="odd.name == 'Favourite' ||  (!is_logged && odd.countryCode == 'AU') || odd.meetingName == 'Trackside'"
                (click)="viewInfoDetails(odd)" class="btn btn-tertiary icon">
                <span class="icon icon-info"></span></button>

              <button [disabled]="odd.countryCode == 'AU'" [ngClass]="{'btn-tertiaryActive':odd.fr_clicked == true}"
                *ngIf="odd.countryCode != 'AU' && odd.priceOdds.priceFraction != undefined && 
                odd.priceOdds.priceFraction != '' && odd.status != 'N'" (click)="setPriceOdd(odd)"
                class="btn btn-tertiary ">
                {{odd.priceOdds.priceFraction}}
              </button>

              <button disabled [ngClass]="{'btn-tertiaryActive':odd.fr_clicked == true}" *ngIf="odd.countryCode == 'AU' && odd.priceOdds.priceDecimal != undefined && odd.priceOdds.priceDecimal != '' && 
                odd.status != 'N'" class="btn btn-tertiary au">
                {{odd.priceOdds.priceDecimal}}
              </button>

              <button class="btn btn-tertiary" (click)="setSPOdd(odd)" *ngIf="odd.status!='N' "
                [ngClass]="{'btn-tertiaryActive':odd.clicked == true}">SP</button>

              <button class="btn btn-tertiary" *ngIf="odd.status=='N' "
                [ngClass]="{'btn-tertiaryActive':odd.clicked == true}">N/R</button>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>